// Microlearning Video mappings for Basissicherheit modules
// Each module has videos for each milieu

// Import all videos statically
const sicherePasswoerterVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Sichere Passwörter/SPasswörter_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Sichere Passwörter/SPasswörter_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Sichere Passwörter/SPasswörter_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Sichere Passwörter/SPasswörter_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Sichere Passwörter/SPasswörter_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Sichere Passwörter/SPasswörter_tra.mp4'),
  };
  
  const mfaVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/MFA/MFA_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/MFA/MFA_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/MFA/MFA_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/MFA/MFA_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/MFA/MFA_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/MFA/MFA_tra.mp4'),
  };
  
  const passwortManagerVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Passwort-Manager/Passwort-Manager_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Passwort-Manager/Passwort-Manager_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Passwort-Manager/Passwort-Manager_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Passwort-Manager/Passwort-Manager_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Passwort-Manager/Passwort-Manager_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Passwort-Manager/Passwort-Manager_tra.mp4'),
  };
  
  const backupsVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Backups/Backups_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Backups/Backups_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Backups/Backups_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Backups/Backups_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Backups/Backups_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Backups/Backups_tra.mp4'),
  };
  
  const updatesVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Automatische Updates/Updates_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Automatische Updates/Updates_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Automatische Updates/Updates_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Automatische Updates/Updates_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Automatische Updates/Updates_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Automatische Updates/Updates_tra.mp4'),
  };
  
  const emailVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Email Account absichern/E-Mail_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Email Account absichern/E-Mail_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Email Account absichern/E-Mail_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Email Account absichern/E-Mail_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Email Account absichern/E-Mail_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Email Account absichern/E-Mail_tra.mp4'),
  };
  
  const adBlockerVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Ad-Blocker/Ad-Blocker_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Ad-Blocker/Ad-Blocker_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Ad-Blocker/Ad-Blocker_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Ad-Blocker/Ad-Blocker_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Ad-Blocker/Ad-Blocker_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Ad-Blocker/Ad-Blocker_tra.mp4'),
  };
  
  const routerVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Router Passwort/RouterPW_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Router Passwort/RouterPW_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Router Passwort/RouterPW_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Router Passwort/RouterPW_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Router Passwort/RouterPW_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Router Passwort/RouterPW_tra.mp4'),
  };
  
  const socialMediaVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/Social Media/SocMed_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/Social Media/SocMed_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/Social Media/SocMed_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/Social Media/SocMed_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/Social Media/SocMed_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/Social Media/SocMed_tra.mp4'),
  };
  
  const appBerechtigungenVideos = {
    ap: require('../assets/Microlearnings/Basissicherheit/App Berechtigungen/App-Berechtigungen_ap.mp4'),
    kg: require('../assets/Microlearnings/Basissicherheit/App Berechtigungen/App-Berechtigungen_kg.mp4'),
    kh: require('../assets/Microlearnings/Basissicherheit/App Berechtigungen/App-Berechtigungen_kh.mp4'),
    öko: require('../assets/Microlearnings/Basissicherheit/App Berechtigungen/App-Berechtigungen_öko.mp4'),
    pre: require('../assets/Microlearnings/Basissicherheit/App Berechtigungen/App-Berechtigungen_pre.mp4'),
    tra: require('../assets/Microlearnings/Basissicherheit/App Berechtigungen/App-Berechtigungen_tra.mp4'),
  };
  
  // Main mapping structure
  export const MICROLEARNING_VIDEOS = {
    'Sichere Passwörter': sicherePasswoerterVideos,
    'MFA': mfaVideos,
    'Passwort-Manager': passwortManagerVideos,
    'Backups': backupsVideos,
    'Automatische Updates': updatesVideos,
    'Email Account absichern': emailVideos,
    'Ad-Blocker': adBlockerVideos,
    'Router Passwort ändern': routerVideos,
    'Social Media': socialMediaVideos,
    'App-Berechtigungen': appBerechtigungenVideos,
  };
  
  // Function to get video for a module and milieu
  export const getMicrolearningVideo = (moduleName, milieuAbbr) => {
    const moduleVideos = MICROLEARNING_VIDEOS[moduleName];
    if (!moduleVideos) {
      return null;
    }
    return moduleVideos[milieuAbbr] || null;
  };
  
  